import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, makeStyles } from '@material-ui/core';
import { Formik, FormikProps } from 'formik';
import { useSnackbar } from 'notistack';
import React, { FunctionComponent, useState } from 'react';
import { useHistory } from "react-router-dom";
import { AppShell } from '../components/molecules/app-shell/AppShell';
import OptTaxRegimeFormComponent from '../components/molecules/OptTaxRegimeFormComponent';
import { useStore } from '../store';

const useStyles = makeStyles((theme) => ({
    controlPaper: {
        width: "100%",
        padding: "8px",
    },
    link: {
        display: 'flex',
        textDecoration: 'none',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    taxRegime: {
        marginBottom: 30
    },
}))

type OptRaxRegimePageState = {
    erpId: string,
    nameOfPensioner: string,
    taxRegime: string,
    message: { type: "error" | "success" | "warning" | "info", text: string } | null,
    rejectReason: string,
    endDate: string
}

type OptRaxRegimePageProps = {
}

export const OptRaxRegimePage: FunctionComponent<OptRaxRegimePageProps> = () => {
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();
    const classes = useStyles();
    const store = useStore();

    const [infoAlertOpen, setInfoAlertOpen] = useState(true);
    const [confiirmationAlertOpen, setConfiirmationAlertOpen] = useState(false);

    const handlePopupInfoClose = (value: any) => {
        setInfoAlertOpen(false);
    }

    const handleConfirmationPopupClose = (value: any) => {
        setConfiirmationAlertOpen(false);
    }

    const handleConfirmation = () => {
        setConfiirmationAlertOpen(false);
    }

    const titleCase = (text: string) => {
        const str = text.toLowerCase().split(' ');
        for (var i = 0; i < str.length; i++) {
            str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
        }
        return str.join(' ');
    }

    const getMaritalStatus = (maritialStat: any) => {
        if (maritialStat == '0') {
            return 'Single'
        }
        else if (maritialStat == 'M' || maritialStat == '1') {
            return 'Married'
        }
        else if (maritialStat == 'U') {
            return 'Unmarried'
        }
        else if (maritialStat == 'W' || maritialStat == '2') {
            return 'Widow'
        }
        else if (maritialStat == 'D' || maritialStat == '3') {
            return 'Divorcee'
        }
        else if (maritialStat == 'P') {
            return 'Physically Challanged'
        }
        else if (maritialStat == '4') {
            return 'NM'
        }
        else if (maritialStat == '5') {
            return 'Sep.'
        }
        else if (maritialStat == '6') {
            return 'Unknown'
        }
        else if (maritialStat == '9') {
            return 'RegCou'
        }
        else if (maritialStat == 'A') {
            return 'RegcRP'
        }
        else {
            return maritialStat
        }
    }

    const getSex = (sex: any) => {
        if (sex == 'M' || sex == '1') {
            return 'Male'
        }
        else if (sex == 'F' || sex == '2') {
            return 'Female'
        }
        else {
            return sex
        }
    }

    const getRelationWith = (relationWith: any) => {
        if (relationWith == 'S') {
            return 'Son'
        }
        else if (relationWith == 'D') {
            return 'Daughter'
        }
        else if (relationWith == 'W') {
            return 'Spouse'
        }
        else if (relationWith == 'F') {
            return 'Father'
        }
        else if (relationWith == 'M') {
            return 'Mother'
        }
        else {
            return relationWith
        }
    }

    return (
        <AppShell>
            <Grid container
                spacing={3}
                direction="column"
                justify="space-around"
                alignItems="stretch">
                <Formik
                    initialValues={{
                        erpId: store.auth.user?.id || '',
                        nameOfPensioner: titleCase(store.auth.user?.name || ''),
                        taxRegime: '2',
                        message: null,
                        rejectReason: '',
                        endDate: '99991231'
                    }}
                    validate={(values) => {
                        const error: Partial<OptRaxRegimePageState> & { general?: string } = {}
                        if (!values.erpId) {
                            error.erpId = "Invalid FPPO no"
                        }
                        // if (!values.erpId || !values.erpId.match(/^9\d{9}$/)) {
                        //     error.erpId = "Invalid ERP ID (অবৈধ ERP আইডি)"
                        // }
                        return error
                    }}
                    onSubmit={() => { }}
                >{({ values, isSubmitting, isValid, setFieldValue, setValues, handleChange, setSubmitting }: FormikProps<OptRaxRegimePageState>) => {
                    return (
                        <OptTaxRegimeFormComponent />
                    )
                }}
                </Formik>

                <Dialog
                    open={infoAlertOpen}
                    onClose={handlePopupInfoClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Alert (সতর্কতা)"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            This application can be used only once in a financial year. (এই অ্যাপ্লিকেশনটি শুধুমাত্র একটি আর্থিক বর্ষে একবার ব্যবহার করা যেতে পারে |)
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        {/* <Button onClick={() => { setInfoAlertOpen(false) }} color="primary">
                            No (না)
                        </Button> */}
                        <Button onClick={() => { setInfoAlertOpen(false) }} color="primary" autoFocus>
                            Ok (ঠিক আছে)
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        </AppShell>
    )
}